// extracted by mini-css-extract-plugin
module.exports = {"custom-drag-layer":"Rls6o","custom-drag-element":"UNGSY"};